import React, { ReactNode } from 'react'
import { Header, LoadingModal } from 'components'
import { NotificationsProvider } from 'commons/customHooks/useNotifications'
import {
  PaperStyled,
  Main,
  WrapContainerStyled,
  GridContainerStyled,
  GridContentStyled
} from './styles'
import { useBreadcrumb } from 'commons/customHooks/useBreadcrumbs'

export interface PageProps {
  children: ReactNode
  hasHeader?: boolean
  renderContent?: boolean
  fullwidth?: boolean
  renderHeaderComponent?: ReactNode
  loading?: boolean
}

export const Page: React.FC<PageProps> = ({
  children,
  hasHeader = true,
  renderContent = true,
  fullwidth = false,
  loading = false,
  renderHeaderComponent = <></>
}) => {
  useBreadcrumb()
  return (
    <>
      {loading && <LoadingModal />}
      <NotificationsProvider>
        <PaperStyled square>
          {hasHeader && <Header />}
          <Main>
            <WrapContainerStyled
              maxWidth={'lg'}
              header={hasHeader ? 1 : 0}
              disableGutters
              fullwidth={fullwidth ? 'true' : 'false'}
            >
              <GridContainerStyled
                container
                direction="column"
                justifyContent="space-between"
              >
                {renderHeaderComponent}
                <GridContentStyled fullwidth={fullwidth ? 'true' : 'false'} item xs={12}>
                  {renderContent && children}
                </GridContentStyled>
              </GridContainerStyled>
            </WrapContainerStyled>
          </Main>
        </PaperStyled>
      </NotificationsProvider>
    </>
  )
}
